import React from 'react';
import Icon from './Icon';

export default function FaqItem({ index, question, answer, open, onToggle }) {
  const num = String(index + 1).padStart(2, '0');
  return (
    <div
      className={`portal-faq-item${open ? ' open' : ''}`}
      onClick={onToggle}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onToggle();
        }
      }}
    >
      <div className="portal-faq-row">
        <span className="portal-faq-num">{num}</span>
        <span className="portal-faq-q">{question}</span>
        <span className="portal-faq-toggle" aria-hidden>
          <Icon name="chevron-down" size={18} className="portal-faq-chevron" />
        </span>
      </div>
      {open && <div className="portal-faq-a">{answer}</div>}
    </div>
  );
}
